/* unplugin-vue-components disabled */import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useConfigurationStore } from '@/stores/configurationModule';
export default {
  __name: 'EditorClipPath',
  props: {
    printSide: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    const configuratorStore = useConfigurationStore();
    const {
      box
    } = storeToRefs(configuratorStore);
    const props = __props;
    const editorClipPathRef = ref(null);
    // fabricCanvasContainer.appendChild(svgElement);
    onMounted(() => {
      const path = box.value.getNormalizedOutlinePathWithBleed(props.printSide);

      // Don't delete comment, used for testing
      // const path = box.value.getOutlinePathWithoutNonPrintPanels(props.printSide)

      const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      const defsElement = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
      const clipPathElement = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
      clipPathElement.setAttribute('id', `clipPath-${props.printSide}`);
      clipPathElement.setAttribute('clipPathUnits', 'objectBoundingBox');
      clipPathElement.innerHTML = path;
      svgElement.setAttribute('width', '0');
      svgElement.setAttribute('height', '0');
      defsElement.appendChild(clipPathElement);
      svgElement.appendChild(defsElement);

      // fabricCanvasContainer.style.clipPath = 'url("#clipPath")';
      if (editorClipPathRef.value) {
        editorClipPathRef.value.appendChild(svgElement);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "editorClipPath",
        class: "editor-clip-path",
        ref_key: "editorClipPathRef",
        ref: editorClipPathRef
      }, [_renderSlot(_ctx.$slots, "default")], 512);
    };
  }
};